var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "detectionData" },
    [
      _c("div", { staticClass: "detectionData-top" }, [
        _c("div", { staticClass: "title" }, [_vm._v("\n      检测报告\n    ")]),
        _vm._v(" "),
        _c("div", { staticClass: "tip" }, [
          _c("div", { staticClass: "tip-list" }, [
            _c("span", [_vm._v("报告编号 ")]),
            _vm._v("\n        " + _vm._s(_vm.viewData.id) + "\n      "),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "tip-list" }, [
            _c("span", [_vm._v("最新检测日期 ")]),
            _vm._v("\n        " + _vm._s(_vm.viewData.updateTime) + "\n      "),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "detectionData-center" },
        [
          _c("el-card", { staticClass: "box-card" }, [
            _c("h3", [_vm._v("核心项核查结论")]),
            _vm._v(" "),
            _c("div", { staticClass: "text" }, [
              _c("span", [_vm._v("事故车检测结论 ")]),
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.viewData.status &&
                      _vm.viewData.status.shigu &&
                      _vm.viewData.status.shigu.txt
                  ) +
                  "\n      "
              ),
            ]),
            _vm._v(" "),
            _vm.viewData.status &&
            _vm.viewData.status.shigu &&
            _vm.viewData.status.shigu.content
              ? _c("div", { staticClass: "tip" }, [
                  _vm._v(_vm._s(_vm.viewData.status.shigu.content)),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "text" }, [
              _c("span", [_vm._v("泡水车检测结论 ")]),
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.viewData.status &&
                      _vm.viewData.status.shuipao &&
                      _vm.viewData.status.shuipao.txt
                  ) +
                  "\n      "
              ),
            ]),
            _vm._v(" "),
            _vm.viewData.status &&
            _vm.viewData.status.shuipao &&
            _vm.viewData.status.shuipao.content
              ? _c("div", { staticClass: "tip" }, [
                  _vm._v(_vm._s(_vm.viewData.status.shuipao.content)),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "text" }, [
              _c("span", [_vm._v("火烧车检测结论 ")]),
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.viewData.status &&
                      _vm.viewData.status.huoshao &&
                      _vm.viewData.status.huoshao.txt
                  ) +
                  "\n      "
              ),
            ]),
            _vm._v(" "),
            _vm.viewData.status &&
            _vm.viewData.status.huoshao &&
            _vm.viewData.status.huoshao.content
              ? _c("div", { staticClass: "tip" }, [
                  _vm._v(_vm._s(_vm.viewData.status.huoshao.content)),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "text" }, [
              _c("span", [_vm._v("里程核查结论 ")]),
              _vm._v("\n        不公示（不选择）\n      "),
            ]),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "detectionData-bottom" },
        _vm._l(_vm.viewData.deviceList, function (item, idx) {
          return _c(
            "el-card",
            { key: "item_" + idx, staticClass: "box-card" },
            [
              _c("h3", [
                _vm._v(_vm._s(item.name) + "\n        "),
                _c(
                  "div",
                  { staticClass: "switch" },
                  [
                    _vm._v("\n          只看问题项\n          "),
                    _c("el-switch", {
                      model: {
                        value: item.switch,
                        callback: function ($$v) {
                          _vm.$set(item, "switch", $$v)
                        },
                        expression: "item.switch",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "text-weight" }, [
                _vm._v(
                  "鉴定车辆与鉴定人员留证(" + _vm._s(item.data.length) + "项)"
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "number" }, [
                _c("div", [
                  _c("img", {
                    attrs: {
                      src: require("@/assets/images/detection/success.png"),
                    },
                  }),
                  _vm._v(_vm._s(item.dataCont.success) + "个检测正常"),
                ]),
                _vm._v(" "),
                _c("div", [
                  _c("img", {
                    attrs: {
                      src: require("@/assets/images/detection/waring.png"),
                    },
                  }),
                  _vm._v(_vm._s(item.dataCont.waring) + "个检测异常"),
                ]),
                _vm._v(" "),
                _c("div", [
                  _c("img", {
                    attrs: {
                      src: require("@/assets/images/detection/errer.png"),
                    },
                  }),
                  _vm._v(_vm._s(item.dataCont.errer) + "个重大事故判定"),
                ]),
              ]),
              _vm._v(" "),
              _vm._l(item.data[0].child, function (list, idx1) {
                return _c("div", { key: "list_" + idx1 }, [
                  list &&
                  list.detail &&
                  list.detail.length > 0 &&
                  !(item.switch && list.status == "success")
                    ? _c(
                        "div",
                        { staticClass: "list" },
                        _vm._l(list.detail, function (detection, index1) {
                          return _c("div", { key: "detection_" + index1 }, [
                            _c(
                              "div",
                              { staticClass: "icon" },
                              [
                                index1 == 0
                                  ? [
                                      list.status == "success"
                                        ? _c("img", {
                                            attrs: {
                                              src: require("@/assets/images/detection/success.png"),
                                            },
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      list.status == "waring"
                                        ? _c("img", {
                                            attrs: {
                                              src: require("@/assets/images/detection/waring.png"),
                                            },
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      list.status == "errer"
                                        ? _c("img", {
                                            attrs: {
                                              src: require("@/assets/images/detection/errer.png"),
                                            },
                                          })
                                        : _vm._e(),
                                    ]
                                  : _vm._e(),
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "detail" },
                              [
                                index1 == 0
                                  ? _c("div", { staticClass: "title" }, [
                                      _c("span", [
                                        _vm._v(
                                          "检测项：" +
                                            _vm._s(list.name) +
                                            "（" +
                                            _vm._s(
                                              _vm._f("filterStatus")(
                                                list.status
                                              )
                                            ) +
                                            "）"
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      list.status != "success"
                                        ? _c("i", {
                                            staticClass: "el-icon-edit",
                                            on: {
                                              click: function ($event) {
                                                return _vm.examineItem(list.id)
                                              },
                                            },
                                          })
                                        : _vm._e(),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                index1 == 0 &&
                                list.shForm &&
                                list.shForm.length > 0
                                  ? _c("div", { staticClass: "examine" }, [
                                      _c("div", [
                                        _vm._v(
                                          "审核" +
                                            _vm._s(list.shForm[0].name) +
                                            "：" +
                                            _vm._s(list.shForm[0].value)
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("div", [
                                        _vm._v(
                                          "审核" +
                                            _vm._s(list.shForm[1].name) +
                                            "：" +
                                            _vm._s(list.shForm[1].value)
                                        ),
                                      ]),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("div", { staticClass: "text" }, [
                                  _c("span", [
                                    _vm._v("缺陷：" + _vm._s(detection.text)),
                                  ]),
                                  _c("span", [
                                    _vm._v("解读：" + _vm._s(detection.notes)),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _vm._l(detection.url, function (img, idx3) {
                                  return _c(
                                    "div",
                                    {
                                      key: "img_" + idx3,
                                      staticClass: "imgbox",
                                    },
                                    [
                                      _c("el-image", {
                                        staticStyle: {
                                          width: "100px",
                                          height: "100px",
                                        },
                                        attrs: {
                                          src: img,
                                          "preview-src-list": [img],
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                }),
                              ],
                              2
                            ),
                          ])
                        }),
                        0
                      )
                    : list && !item.switch
                    ? _c("div", { staticClass: "list" }, [
                        _c(
                          "div",
                          { staticClass: "icon" },
                          [
                            [
                              list.status == "success"
                                ? _c("img", {
                                    attrs: {
                                      src: require("@/assets/images/detection/success.png"),
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              list.status == "waring"
                                ? _c("img", {
                                    attrs: {
                                      src: require("@/assets/images/detection/waring.png"),
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              list.status == "errer"
                                ? _c("img", {
                                    attrs: {
                                      src: require("@/assets/images/detection/errer.png"),
                                    },
                                  })
                                : _vm._e(),
                            ],
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "detail" }, [
                          _c("div", { staticClass: "title" }, [
                            _c("span", [
                              _vm._v(
                                "检测项：" +
                                  _vm._s(list.name) +
                                  "（" +
                                  _vm._s(_vm._f("filterStatus")(list.status)) +
                                  "）"
                              ),
                            ]),
                          ]),
                        ]),
                      ])
                    : _vm._e(),
                ])
              }),
            ],
            2
          )
        }),
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "white-box" }),
      _vm._v(" "),
      _c("examine-dialog", { ref: "examineDialog", on: { isOk: _vm.isOk } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }